import { render } from "./email-activate-modal.vue?vue&type=template&id=058af15a&ts=true"
import script from "./email-activate-modal.vue?vue&type=script&lang=ts"
export * from "./email-activate-modal.vue?vue&type=script&lang=ts"

import "./email-activate-modal.vue?vue&type=style&index=0&id=058af15a&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__